// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__11Uyl","label":"styles_label__8tRzi"};